import { queryClient as defaultQueryClient } from '@/plugins/vueQuery';
import { queryKeys } from '../constants';
import type { QueryInvalidationParams } from '@/types/query';

const MODULE_KEY = 'users';

/** Query Key Getters */

export const getMeQueryKey = () => [MODULE_KEY, queryKeys.ME];

/** Independent of `getMeQueryKey`. Both `/me` versions fetch at session start. */
export const getMeV3QueryKey = () => [MODULE_KEY, queryKeys.ME_V3];

export const getUserPermissionsQueryKey = (userTwrn?: string | null) => {
  const key = [MODULE_KEY, queryKeys.USER_PERMISSIONS];

  if (userTwrn) {
    key.push(userTwrn);
  }

  return key;
};

export const getUserPermissionsListQueryKey = () => [MODULE_KEY, queryKeys.USER_PERMISSIONS_LIST];

/** Separate from the legacy list key: the v3 list has a different shape and endpoint. */
export const getUserPermissionsListV3QueryKey = () => [MODULE_KEY, queryKeys.USER_PERMISSIONS_LIST_V3];

/** One user's saved grants for the v3 edit drawer. Distinct from the legacy per-team detail key. */
export const getUserPermissionGrantsV3QueryKey = (userTwrn?: string | null) => {
  const key = [MODULE_KEY, queryKeys.USER_PERMISSION_GRANTS_V3];

  if (userTwrn) {
    key.push(userTwrn);
  }

  return key;
};

export const getNotificationSettingsQueryKey = (userTwrn?: string | null) => {
  const key = [MODULE_KEY, queryKeys.NOTIFICATION_SETTINGS];

  if (userTwrn) {
    key.push(userTwrn);
  }

  return key;
};

/** Invalidation Helpers */

export const invalidateUserPermissions = (
  userTwrn?: string | null,
  options?: QueryInvalidationParams,
) => {
  const client = options?.queryClient ?? defaultQueryClient;

  // The listing shows all users, so always invalidate it regardless of userTwrn.
  client.invalidateQueries({ queryKey: getUserPermissionsListQueryKey() });
  // With no userTwrn this is a broader prefix, invalidating every detail query.
  client.invalidateQueries({ queryKey: getUserPermissionsQueryKey(userTwrn) });
};
